"use strict";

exports.__esModule = true;
// Generated by CoffeeScript 1.12.6
var pull;

exports.default = pull = function (list, value) {
  var i;
  if (list != null && (i = list.indexOf(value)) > -1) {
    list.splice(i, 1);
    return true;
  } else {
    return false;
  }
};